import React from 'react';
import { Box, Container, Typography, Grid, Link, TextField, Button, IconButton } from '@mui/material';
import { 
  Facebook as FacebookIcon, 
  Twitter as TwitterIcon, 
  LinkedIn as LinkedInIcon, 
  Instagram as InstagramIcon,
  Business as BusinessIcon
} from '@mui/icons-material';

const Footer = () => {
  return (
    <Box component="footer" className="custom-footer" sx={{ py: 6, mt: 'auto' }}>
      <Container maxWidth="lg" className="footer-content">
        <Grid container spacing={4}>
          {/* Logo y descripción */}
          <Grid item xs={12} sm={4} className="footer-section">
            <div className="footer-logo">
              <div className="footer-logo-icon">
                <BusinessIcon />
              </div>
              <span className="footer-logo-text">MetalConnect</span>
            </div>
            <Typography variant="body2">
              La plataforma líder para conectar proveedores y consumidores de metales. 
              Facilitamos el comercio B2B con soluciones innovadoras y confiables.
            </Typography>
            
            {/* Redes sociales */}
            <div className="footer-social">
              <IconButton className="social-icon" aria-label="Facebook">
                <FacebookIcon />
              </IconButton>
              <IconButton className="social-icon" aria-label="Twitter">
                <TwitterIcon />
              </IconButton>
              <IconButton className="social-icon" aria-label="LinkedIn">
                <LinkedInIcon />
              </IconButton>
              <IconButton className="social-icon" aria-label="Instagram">
                <InstagramIcon />
              </IconButton>
            </div>
          </Grid>

          {/* Enlaces de servicios */}
          <Grid item xs={12} sm={4} className="footer-section">
            <Typography variant="h6" gutterBottom>
              Servicios
            </Typography>
            <ul className="footer-links">
              <li><Link href="/products" color="inherit">Catálogo de Productos</Link></li>
              <li><Link href="/rfq" color="inherit">Solicitudes de Cotización</Link></li>
              <li><Link href="/chat" color="inherit">Chat en Tiempo Real</Link></li>
              <li><Link href="/dashboard" color="inherit">Dashboard Empresarial</Link></li>
              <li><Link href="/publish-product" color="inherit">Publicar Productos</Link></li>
            </ul>
          </Grid>

          {/* Información de contacto */}
          <Grid item xs={12} sm={4} className="footer-section">
            <Typography variant="h6" gutterBottom>
              Contacto
            </Typography>
            <Typography variant="body2" paragraph>
              Email: info@metalconnect.com
            </Typography>
            <Typography variant="body2" paragraph>
              Teléfono: +1 (555) 123-4567
            </Typography>
            <Typography variant="body2" paragraph>
              Dirección: Av. Industrial 123, Ciudad Industrial, CP 12345
            </Typography>
            <Typography variant="body2">
              Horario: Lunes a Viernes 8:00 AM - 6:00 PM
            </Typography>
          </Grid>
        </Grid>

        {/* Newsletter */}
        <div className="newsletter-section">
          <Typography variant="h6" className="newsletter-title">
            Mantente Informado
          </Typography>
          <Typography variant="body2" className="newsletter-subtitle">
            Recibe las últimas noticias sobre precios de metales y oportunidades de negocio
          </Typography>
          <div className="newsletter-form">
            <TextField
              className="newsletter-input"
              placeholder="Tu email"
              variant="outlined"
              size="small"
            />
            <Button className="newsletter-button">
              Suscribirse
            </Button>
          </div>
        </div>

        {/* Footer inferior */}
        <Box className="footer-bottom">
          <Typography variant="body2">
            © 2024 MetalConnect. Todos los derechos reservados. | 
            <Link href="/privacy" color="inherit" sx={{ ml: 1 }}>Política de Privacidad</Link> | 
            <Link href="/terms" color="inherit" sx={{ ml: 1 }}>Términos de Servicio</Link>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 